<!--- Formulario PCTransfer ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-
Eventos escuchados por el componente:
-----------------------

Eventos generados por el componente:
-----------------------
-  XXXXXXX ->
--->

<template>
  <div>
    <div class="content-gestion-traspasos">
      <div class="content-gestion-traspasos__cabecera padding-horizontal padding-vertical-half">
        <div>
          <!--
          <img
            src="@/static/icons/ic_print.svg"
            :class="{ 'disabled': !print}"
            @click="PrintLabel(palePrint)"
          >
          -->
          <div v-if="mainData != null && mainData.InfoNuevoPale == null">
            <span class="content-gestion-traspasos__cabecera--strong">
              {{
                paletSelected != null
                  ? paletSelected.UnidadContenedora.NumeroSerie
                  : $t('common.logisticsUnit')
              }}
            </span>
            <div
              v-if="paletSelected != null"
            >
              <span
                v-if="paletSelected.UnidadContenedora.InfoEnvase != null"
                class="content-gestion-traspasos__cabecera--ligh"
              >
                {{ paletSelected.UnidadContenedora.InfoEnvase.Nombre }}
              </span>
              <span v-else>
                {{ GetContainerFromPale(paletSelected.UnidadContenedora) }}
              </span>
            </div>
          </div>
          <div
            v-else
            class="content-gestion-traspasos__cabecera--strong"
          >
            {{ $t('commercialization.common.newPallet') }}
          </div>
        </div>
        <div>
          <span class="content-gestion-traspasos__cabecera--ligh">
            {{ $t('commercialization.picking.palletizing.labels.currentPackages') }}
          </span>
          <span class="content-gestion-traspasos__cabecera--strong">
            <!-- eslint-disable-next-line @intlify/vue-i18n/no-raw-text -->
            {{ paletSelected != null ? paletSelected.CajasReservadas : 0 }}
          </span>
        </div>
        <div>
          <span class="content-gestion-traspasos__cabecera--ligh">
            {{ $t('commercialization.picking.palletizing.labels.packagesToTransfer') }}
          </span>
          <span
            v-if="configuracionLecturaCajasFrmPicking.LecturaEnTraspaso && selectedOrderLine != null && selectedOrderLine.LineaPedidoVenta != null"
            class="content-gestion-traspasos__cabecera--strong"
          > {{ `${sumaTotalCajasTraspasar} / ${selectedOrderLine.LineaPedidoVenta.EnvasesPorPalet}` }}</span>
          <span
            v-else
            class="content-gestion-traspasos__cabecera--strong"
          > {{ sumaTotalCajasTraspasar }}</span>
        </div>
        <div class="content-gestion-traspasos__cabecera--buttons">
          <img
            alt="iconQr"
            src="@/static/icons/ic_qr.svg"
            @click="OpenReadBarCode"
          >
        </div>
      </div>

      <!-- <f7-block class="pletizado__cabecera">
        <f7-row>
          <f7-col
            class="padding-right padding-top text-1 margin-top
                  display-flex flex-direction-row"
            width="35"
          >
            <div class="print">
              <f7-button>
                <img src="@/static/icons/ic_print.svg">
              </f7-button>
            </div>
            <div v-if="mainData.InfoNuevoPale === null">
              {{ paletSelected != null ? paletSelected.UnidadContenedora.NumeroSerie : $t('common.logisticsUnit') }}
              <div
                v-if="paletSelected != null"
                class="container__palet--sub-id"
              >
                <span v-if="paletSelected.UnidadContenedora.InfoEnvase != null">{{ paletSelected.UnidadContenedora.InfoEnvase.Nombre }} </span>
                <span v-else> {{ GetContainerFromPale(paletSelected.UnidadContenedora) }} </span>
              </div>
            </div>
            <div v-else>
              Nuevo Palé
            </div>
          </f7-col>
          <f7-col
            class="padding display-flex flex-direction-row margin-top"
            width="25"
          >
            <div class="text-2">
              Envases actuales:
            </div>
            <div class="text-1">
              {{ paletSelected != null ? paletSelected.CajasReservadas : 0 }}
            </div>
          </f7-col>
          <f7-col
            class="padding display-flex flex-direction-row margin-top"
            width="25"
          >
            <div class="text-2">
              Envase traspasar:
            </div>
            <div
              class="text-1"
            >
              {{ sumaTotalCajasTraspasar }}
            </div>
          </f7-col>
          <f7-col width="10">
            <div class="qr padding">
              <img
                src="@/static/icons/ic_qr.svg"
                @click="OpenReadBarCode"
              >
            </div>
          </f7-col>
        </f7-row>
      </f7-block> -->

      <div
        v-if="mainData != null && mainData.Mercancia.length > 0 "
        class="content-gestion-traspasos__list"
      >
        <div
          v-for="(option, i) in mainData.Mercancia"
          :key="i"
          class="content-gestion-traspasos__item padding-horizontal padding-vertical-half"
        >
          <div>
            <span class="content-gestion-traspasos__item--strong">
              {{ option.NumeroSerie }}
            </span>
            <!-- {{ option != null && option.PuntoPaletizadoConfeccion != undefined ? option.PuntoPaletizadoConfeccion.Codigo : "Sin punto de paletizado" }} -->
            <span
              v-if="option.InfoEnvase != null"
              class="content-gestion-traspasos__item--ligh"
            >{{ option.InfoEnvase.Nombre }} </span>
            <span
              v-else
              class="content-gestion-traspasos__item--ligh"
            > {{ GetContainerFromPale(option) }} </span>
          </div>

          <div>
            <span class="content-gestion-traspasos__item--ligh">
              {{ $t('commercialization.picking.palletizing.labels.availableBoxes') }}
            </span>
            <span class="content-gestion-traspasos__item--strong">
              {{ option.CajasDisponibles }}
            </span>
          </div>

          <div class="content-gestion-traspasos__item--counter">
            <span class="content-gestion-traspasos__item--ligh">
              {{ $t('commercialization.picking.palletizing.labels.boxesToTransfer') }}
            </span>
            <div v-if="!configuracionLecturaCajasFrmPicking.LecturaEnTraspaso">
              <UCInputIncrement
                :val="option.CajasTraspasar"
                :max-valor="option.CajasDisponibles"
                @value="ChangeValueArray($event, i)"
              />
            </div>
            <div v-else>
              <span class="content-gestion-traspasos__item--strong display-flex margin-top-half"> {{ option.CajasTraspasar }}</span>
            </div>
          </div>

          <div>
            <img
              v-if="configuracionLecturaCajasFrmPicking.LecturaEnTraspaso"
              alt="iconBox"
              width="30px"
              src="@/static/icons/ic_batch_blue.svg"
              @click="OpenLineBoxes(option)"
            >
            <img
              alt="iconDelete"
              src="@/static/icons/ic_delete.svg"
              @click="DeletePaleSelection(option)"
            >
            <img
              alt="iconPopup"
              src="@/static/icons/ic_options_gray.svg"
              @click="OpenPopupPaleData(option)"
            >
          </div>
        </div>
      </div>

      <f7-block class="content-paletizado-buttons padding">
        <f7-row>
          <f7-col>
            <f7-button
              v-if="selectedEditPale == null
                && (mainData != null && mainData.Base == null && mainData.InfoNuevoPale == null)"
              color="orange"
              fill
              class="color-letra"
              @click="PressNewPalet()"
            >
              {{ $t('commercialization.common.newPallet') }}
            </f7-button>
          </f7-col>

          <f7-col class="display-flex justify-content-flex-end">
            <f7-button
              color="gray"
              @click="PressCancel"
            >
              {{ $t('common.cancel') }}
            </f7-button>
            <f7-button
              class="margin-left"
              :class="{ disabled: !btnOkEnable }"
              fill
              color="green"
              @click="PressConfirmar"
            >
              {{ $t('common.confirm') }}
            </f7-button>
          </f7-col>
        </f7-row>
      </f7-block>
      <!-- Main Data: <pre>{{ mainData }} </pre> -->
    </div>
    <PCLecturaCajasPicking
      ref="PCLecturaCajasPicking"
      @close-popup-click="CerrarPopupLecturaDeCajas"
    />

    <!-- popup crear nuevo palet desde cero cuando estamos en la pestaña de gestionar reserva -->
    <PCPopupGetDataForNewPale
      ref="PCPopupGetDataForNewPale"
      :selected-pale="orderLine"
      :con-pedido="conPedido"
      @confirm="ConfirmNewDataForNewPale"
    />
    <!--
 -->    <!-- popup mostrar datos despues del escaneo de pale -->
    <PCPopupScanData
      ref="PCPopupScanData"
      @confirm="ConfirmScanData"
    />

    <!-- popup mostrar datos especificos de cada palé -->
    <PCPopupPaleData
      ref="PCPopupPaleData"
    />

    <UCCodeScanner
      ref="UCCodeScanner"
      :allow-manual-code-entry="true"
      :fab-button-show="false"
      :auto-open-camera="true"
      @code-reading="BarCodeReadingEvent"
      @codigo-barras="BarCodeReadingEvent"
      @numero-serie="NumeroSerieReadingEvent"
    />
    <UCConfirmation ref="UCConfirmationTransfer" />
  </div>
</template>

<script>
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import UCInputIncrement from '@/components/common/UCInputIncrement.vue';
import { LogDetails as Log, LogError } from '@/js/common/HIDebuggingSupport';
import UCConfirmation from '@/components/common/UCConfirmation.vue';
import ConexionTA from '@/js/services/traceability/APITraceability';
import { ComponentState } from '@/js/common/enum';
import { TipoMovimientoPicking } from '@/js/services/traceability/enumeradosTA';
import PCPopupGetDataForNewPale from '@/components/production/commercialization/picking/PCPopupGetDataForNewPale.vue';
import PCPopupScanData from '@/components/production/commercialization/picking/PCPopupScanData.vue';
import PCPopupPaleData from '@/components/production/commercialization/picking/PCPopupPaleData.vue';
import {
  HiDialog,
  HiNotification,
  PreloaderGH,
} from '@/js/common/HINotificationSupport';
import { callExecuteSPERP } from '@/js/services/APIErp';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';
import PCLecturaCajasPicking from './PCLecturaCajasPicking.vue';

/** @import { UnidadContenedora } from '@erpagroapp/types' */

export default {

  name: 'PCTransfer',
  components: {
    UCInputIncrement,
    UCCodeScanner,
    UCConfirmation,
    PCPopupGetDataForNewPale,
    PCPopupScanData,
    PCPopupPaleData,
    PCLecturaCajasPicking,
  },
  props: {
    conPedido: { type: Boolean, default: true },
    selectedEditPale: { type: Object, default: null },
    selectManageReservation: {
      type: Boolean,
      default: false,
    },
    selectedOrderLine: {
      type: Object,
      default: null,
    },
  },

  emits: [
    'stateChange',
    'confirmation',
    'cancellation',
  ],

  data() {
    return {
      paletSelected: null, // palet seleccionado
      mainData: null,
      sumaTotalCajasTraspasar: 0,
      manageReservation: false, // se ha pulsado el btn de gestionar reserva
      orderLine: null, // lineaPedido marina
      palePrint: null, // imprimir etiqueta pale
      articuloElaboradoSelected: null,
      paleSelected: {},
      mantenerReservaPaleOrigenTraspasoMovilidad: useParamRef('MantenerReservaPaleOrigenTraspasoMovilidad'),
      replanificarCantidadPaleTraspasadoOReprocesado: useParamRef('ReplanificarCantidadPaleTraspasadoOReprocesado'),
      configuracionLecturaCajasFrmPicking: {
        LecturaEnTraspaso: useSettingRef('Picking.LecturaCajas.LecturaEnTraspaso'),
      },
    };
  },
  computed: {
    componentState() {
      return this.mainData
        && (
          (this.mainData.Base && !this.selectedEditPale)
          || (this.mainData.Mercancia && this.mainData.Mercancia.length > 0)
          || (this.mainData.InfoNuevoPale)
          || (this.mainData.Base && this.selectedEditPale && this.mainData.Mercancia && this.mainData.Mercancia.length > 0))

        ? ComponentState.EDIT : ComponentState.INITIAL;
    },
    btnOkEnable() {
      return (this.mainData && this.mainData.Mercancia && this.mainData.Mercancia.length > 0)
        && (this.mainData.Base || this.mainData.InfoNuevoPale)
        && this.sumaTotalCajasTraspasar > 0;
    },
    print() {
      return (this.paletSelected != null);
    },
  },
  watch: {
    print(val) {
      if (val) {
        Log(this, 'PCTransfer->watch->selectedEditPale');
        this.palePrint = this.paletSelected;
      }
    },
    selectedEditPale(val) {
      if (val != null) {
        Log(this, 'PCTransfer->watch->selectedEditPale');
        this.SelectedEditPaleRecibed(val);
      }
    },
    selectManageReservation(val) {
      Log(this, 'PCTransfer->watch->selectManageReservation');
      this.manageReservation = val;
    },
    selectedOrderLine(val) {
      this.orderLine = val;
    },
    componentState(val) {
      this.$emit('stateChange', val);
    },
  },

  mounted() {
    Log(this, 'PCTransfer->mounted');
    this.StartComponent();
  },

  methods: {
    /**
     * @public
     * @returns {void}
     */
    StartComponent() {
      Log(this, this.StartComponent.name);
      // this.componentState = ComponentState.INITIAL;

      this.mainData = {
        TipoMovimiento: TipoMovimientoPicking.TRASPASO,
        Base: null,
        Mercancia: [],
        InfoNuevoPale: null,
      };
      this.orderLine = this.selectedOrderLine;
    },

    /**
     * @public
     * @returns {void}
     */
    ResetComponent() {
      this.mainData = {
        TipoMovimiento: TipoMovimientoPicking.TRASPASO,
        Base: null,
        Mercancia: [],
        InfoNuevoPale: null,
      };
      this.paletSelected = null;
      this.sumaTotalCajasTraspasar = 0;
    },
    ChangeValueArray(val, pos) {
      Log(this, this.ChangeValueArray.name);
      this.mainData.Mercancia[pos].CajasTraspasar = val;
      this.CalculateTotalBoxesTransfer();
    },
    PressConfirmar() {
      Log(this, this.PressConfirmar.name);

      this.$refs.UCConfirmationTransfer.create(
        this.$t('commercialization.picking.palletizing.transfer.confirm.title'),
        this.$t('commercialization.picking.palletizing.transfer.confirm.text'),
        this.Confirmar,
      );
      this.$refs.UCConfirmationTransfer.show();
    },
    async Confirmar() {
      Log(this, this.Confirmar.name);

      if (this.configuracionLecturaCajasFrmPicking.LecturaEnTraspaso) {
        this.FiltrarArticulosElaborados();
      } else {
        this.EliminarArticulosElaborados();
      }

      if (this.mainData.InfoNuevoPale != null) {
        this.mainData.Base = {
          NumeroSerie: 'Nuevo Palé',
          CajasDisponibles: 0,
          CajasTraspasar: this.sumaTotalCajasTraspasar,
        };
      }
      // esperar a que se cierre la ventana de confirmacion
      await sleep(200);

      this.$emit('confirmation', this.mainData);
      this.ResetComponent();
      f7.actions.close();
    },

    PressNewPalet() {
      Log(this, this.PressNewPalet.name);
      this.$refs.PCPopupGetDataForNewPale.Show();
    },
    CalculateTotalBoxesTransfer() {
      Log(this, this.CalculateTotalBoxesTransfer.name);
      this.sumaTotalCajasTraspasar = 0;
      for (let i = 0; i < this.mainData.Mercancia.length; i += 1) {
        const element = this.mainData.Mercancia[i];
        const numCajas = Number.parseInt(element.CajasTraspasar, 10);
        this.sumaTotalCajasTraspasar += numCajas;
      }
      if (this.mainData.Base !== null) {
        this.mainData.Base.CajasTraspasar = this.sumaTotalCajasTraspasar;
      }
    },
    SelectedEditPaleRecibed(value) {
      Log(this, this.SelectedEditPaleRecibed.name);

      this.paletSelected = value;
      this.mainData.Base = this.paletSelected;
    },
    PressCancel() {
      Log(this, this.PressCancel.name);
      this.$emit('cancellation');
      this.manageReservation = false;
      this.ResetComponent();
    },

    InitInputMaxValue() {
      Log(this, this.InitInputMaxValue.name);
      for (let index = 0; index < this.mainData.Mercancia.length; index += 1) {
        this.mainData.Mercancia[index].CajasTraspasar = this.mainData.Mercancia[index].CajasDisponibles;
      }
    },
    OpenReadBarCode() {
      Log(this, this.OpenReadBarCode.name);
      this.$refs.UCCodeScanner.Open();
    },
    OpenPopupPaleData(value) {
      this.$refs.PCPopupPaleData.Show(value);
    },

    OpenLineBoxes(mercancia) {
      Log(this, this.OpenLineBoxes.name);
      this.paleSelected = mercancia;
      this.MostrarPopupLecturaDeCajas();
    },

    async MostrarPopupLecturaDeCajas() {
      Log(this, this.MostrarPopupLecturaDeCajas.name);
      this.$refs.PCLecturaCajasPicking.OpenPopup(this.paleSelected);
    },

    CerrarPopupLecturaDeCajas() {
      Log(this, this.CerrarPopupLecturaDeCajas.name);
      // this.$refs.UCCodeScanner.ClosePopupReadCode();
      const articulosElaboradosChecked = this.paleSelected.ArticulosElaborados.filter((f) => f.checked).length;
      this.paleSelected.CajasTraspasar = articulosElaboradosChecked;
      this.CalculateTotalBoxesTransfer();
    },

    FiltrarArticulosElaborados() {
      Log(this, this.FiltrarArticulosElaborados.name);
      this.mainData.Mercancia.forEach((m) => {
        m.ArticulosElaborados = m.ArticulosElaborados.filter((f) => f.checked);
      });
    },

    EliminarArticulosElaborados() {
      Log(this, this.EliminarArticulosElaborados.name);
      this.mainData.Mercancia.forEach((m) => {
        m.ArticulosElaborados = [];
      });
    },

    IntroducirPropiedadChecked(paleLeido) {
      Log(this, this.IntroducirPropiedadChecked.name);
      paleLeido.ArticulosElaborados.forEach((ae) => {
        if (this.articuloElaboradoSelected !== null && ae.IdUnicoCodigoBarras === this.articuloElaboradoSelected[0].IdUnicoCodigoBarras) {
          ae.checked = true;
        } else {
          ae.checked = false;
        }
      });
    },

    async BarCodeReadingEvent(code) {
      Log(this, this.BarCodeReadingEvent.name);
      let paleLeido = null;
      HiDialog.Preloader(true, this.$t('codeScanner.info.validatingBarcode'));

      let modifiedCode = code;

      // Si el código es mayor a 13 dígitos, nos quedamos con los 20 últimos
      if (code.length > 13) {
        modifiedCode = code.slice(-20);
      }

      const result = await ConexionTA.callObtenePalePorCodigoDeBarras(modifiedCode, true, false, true);
      HiDialog.Preloader(false);
      if (result.Valor) {
        paleLeido = JSON.parse(result.Mensaje);
        if (paleLeido.Existencias.length === 0) {
          HiNotification.Alert(this.$t('codeScanner.info.serialNumberNotInStock'), this.$t('common.error'));
          return;
        }
        this.$refs.PCPopupScanData.Show(paleLeido);
      } else {
        // Comprobar que, si no es un palé, sea un Artículo Elaborado
        try {
          const resultado = await callExecuteSPERP('APPERPAGRO_ArticuloNumeroSerieXArticuloElaborado', [
            { NombreParametro: 'codigoArticuloElaborado', Valor: modifiedCode },
          ], 'Almacen.UnidadContenedoraJSON');

          if (resultado.statusText === 'OK' && resultado.data.length > 0) {
            paleLeido = { ...resultado.data[0] };
            this.articuloElaboradoSelected = paleLeido.ArticulosElaborados.filter((f) => f.IdUnicoCodigoBarras.toString() === modifiedCode);
            this.$refs.PCPopupScanData.Show(paleLeido);
          } else {
            HiNotification.Alert(result.Mensaje, this.$t('common.error'));
          }
        } catch {
          HiNotification.Alert(result.Mensaje, this.$t('common.error'));
        }
      }
    },

    async NumeroSerieReadingEvent(code) {
      Log(this, this.NumeroSerieReadingEvent.name);
      let paleLeido = null;

      const preloaderText = this.$t('codeScanner.info.validatingSerialNumber');
      const cancellationText = this.$t('codeScanner.info.validationCanceled');
      PreloaderGH(true, true, preloaderText, cancellationText);

      const result = await ConexionTA.callObtenePalePorNumeroDeSerie(code, true, false, true);
      PreloaderGH(false);
      if (result.Valor) {
        paleLeido = JSON.parse(result.Mensaje);
        if (paleLeido.Existencias.length === 0) {
          HiNotification.Alert(this.$t('codeScanner.info.serialNumberNotInStock'), this.$t('common.error'));
          return;
        }
        this.$refs.PCPopupScanData.Show(paleLeido);
      } else {
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      }
    },
    async ProcessPaleRead(newPaleRead) {
      Log(this, this.ProcessPaleRead.name);
      const tempAcumExistenciaProductos = newPaleRead.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Producto' || e.Articulo.TipoArticulo === '0'); // TODO
      const tempAcumExitenciasEnvases = newPaleRead.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Envase' || e.Articulo.TipoArticulo === '1'); // TODO
      newPaleRead.InfoProducto = tempAcumExistenciaProductos[0].Articulo;
      newPaleRead.InfoEnvase = tempAcumExitenciasEnvases[0].Articulo;
      newPaleRead.InfoEnvase.Nombre = tempAcumExistenciaProductos.length === 1 ? newPaleRead.InfoEnvase.Nombre : `${newPaleRead.InfoEnvase.Nombre} (+)`;
      newPaleRead.CajasDisponibles = tempAcumExitenciasEnvases.reduce((accumulator, object) => accumulator + object.Cantidad, 0);
      newPaleRead.CajasTraspasar = newPaleRead.CajasDisponibles; // Proponemos el total

      // A - Añadir como Base
      if (this.mainData.Base === null && this.mainData.InfoNuevoPale === null) {
        const allowUsePaleInBase = await this.ValidateUsePaleInBase(newPaleRead);
        if (allowUsePaleInBase) {
          this.mainData.Base = newPaleRead;
          this.paletSelected = {
            UnidadContenedora: newPaleRead,
            CajasReservadas: newPaleRead.CajasDisponibles,
          };
        }
        return; // Se añade solo en la base
      }
      // B - Añadir como Mercancía.
      const allowUsePaleInMerchandise = await this.ValidateUsePaleInMerchandise(newPaleRead);
      if (!allowUsePaleInMerchandise) {
        return;
      }

      this.mainData.Mercancia.push(newPaleRead);
      this.mainData.LineaPedidoVentaOrigen = newPaleRead.LineaPedidoVentaOrigen ?? null;

      // this.EmitEventEstado();
      this.CalculateTotalBoxesTransfer();

      if (this.configuracionLecturaCajasFrmPicking.LecturaEnTraspaso) {
        this.paleSelected = newPaleRead;
        this.IntroducirPropiedadChecked(this.paleSelected);
        this.MostrarPopupLecturaDeCajas();
      }
    },
    async ValidateUsePaleInBase(newPaleRead) {
      Log(this, this.ValidateUsePaleInBase.name);
      // 4.1.1. La unidad logística debe estar reservada al pedido seleccionado,
      // en caso de no tener reservas o estar reservada a otro pedido no es valida.
      const infoUL = await this.GETInfoPickingUL(newPaleRead.Id);
      if (this.conPedido) {
        if (infoUL.Reservas == null || infoUL.Reservas.length === 0) {
          HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.noReservation'));
          return false;
        }

        if (infoUL.Reservas) {
          const reservaOtroPedido = infoUL.Reservas.find((r) => r.LineaPedidoVenta != null
            && r.LineaPedidoVenta.PedidoVenta != null
            && r.LineaPedidoVenta.PedidoVenta.Id !== this.selectedOrderLine.LineaPedidoVenta.PedidoVenta.Id);
          if (reservaOtroPedido != null) {
            HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.reservationInOtherOrder', {
              serial: reservaOtroPedido.LineaPedidoVenta.PedidoVenta.Serie,
              number: reservaOtroPedido.LineaPedidoVenta.PedidoVenta.Numero,
            }));
            return false;
          }
        }
      }
      return true;
    },
    async ValidateUsePaleInMerchandise(newPaleRead) {
      Log(this, this.ValidateUsePaleInMerchandise.name);
      if (this.mainData.Base != null && this.mainData.Base.NumeroSerie === newPaleRead.NumeroSerie) {
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.palletAsBase'));
        return false;
      } if (this.mainData.Base != null && this.mainData.Base.UnidadContenedora != null && newPaleRead.NumeroSerie === this.mainData.Base.UnidadContenedora.NumeroSerie) {
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.palletAsBase'));
        return false;
      } if (this.mainData.Mercancia.filter((m) => m.NumeroSerie === newPaleRead.NumeroSerie).length > 0) {
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.palletAsMerchandise'));
        return false;
      }
      PreloaderGH(true, true, this.$t('commercialization.info.validatingPallet'), '');
      const infoUL = await this.GETInfoPickingUL(newPaleRead.Id);
      PreloaderGH(false);
      if (infoUL.Reservas != null && infoUL.Reservas.length > 0) {
        const reservaOtroPedido = infoUL.Reservas.find((r) => r.LineaPedidoVenta != null
          && r.LineaPedidoVenta.PedidoVenta != null
          && (!this.selectedOrderLine || r.LineaPedidoVenta.PedidoVenta.Id !== this.selectedOrderLine.LineaPedidoVenta.PedidoVenta.Id));
        if (reservaOtroPedido != null) {
          newPaleRead.LineaPedidoVentaOrigen = reservaOtroPedido.LineaPedidoVenta;

          const result = await new Promise((resolve) => {
            this.$refs.UCConfirmationTransfer.create(
              this.$t('commercialization.picking.palletizing.info.reservationInOtherOrderConfirm.title'),
              this.$t('commercialization.picking.palletizing.info.reservationInOtherOrderConfirm.text', {
                serial: reservaOtroPedido.LineaPedidoVenta.PedidoVenta.Serie,
                number: reservaOtroPedido.LineaPedidoVenta.PedidoVenta.Numero,
              }),
              async () => {
                if (
                  this.mantenerReservaPaleOrigenTraspasoMovilidad
                  || this.replanificarCantidadPaleTraspasadoOReprocesado
                ) {
                  return resolve(true);
                }

                const resultRemoveReservation = await this.RemoveReservationPale(newPaleRead, false);
                return resolve(resultRemoveReservation);
              },
              () => {
                resolve(false);
              },
            );
            this.$refs.UCConfirmationTransfer.show();
          });
          return result;
        }
        const reservaMismoPedido = infoUL.Reservas.find((r) => r.LineaPedidoVenta != null
          && r.LineaPedidoVenta.PedidoVenta != null
          && r.LineaPedidoVenta.PedidoVenta.Id === this.selectedOrderLine.LineaPedidoVenta.PedidoVenta.Id);
        if (reservaMismoPedido != null) {
          if (this.mantenerReservaPaleOrigenTraspasoMovilidad) {
            return true;
          }
          HiNotification.Toast(this.$t('commercialization.picking.palletizing.info.reservationInSameOrder'));
          return false;
        }
      }
      return true;
    },
    async RemoveReservationPale(info, restoreMerchandiseToOrigin) {
      Log(this, this.RemoveReservationPale.name);

      PreloaderGH(true, true, this.$t('commercialization.picking.palletizing.removeReservation.preloaderText'), '');
      try {
        const result = await this.SENDDeleteReservation([{ Reserva: { Id: 0 }, UnidadContenedoraOrigenTraspaso: null, UnidadContenedora: { Id: info.Id } }], restoreMerchandiseToOrigin);
        PreloaderGH(false);
        if (!result) {
          HiNotification.Toast(this.$t('commercialization.picking.palletizing.removeReservation.error'));
          return false;
        }
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.removeReservation.success'));
        return true;
      } catch (error) {
        LogError(this, this.RemoveReservationPale.name, error);
        PreloaderGH(false);
        HiNotification.Toast(this.$t('commercialization.picking.palletizing.removeReservation.error'));
        return false;
      }
    },

    ConfirmTypePackagingReprocessed(newPackagingReprocessed) {
      Log(this, this.ConfirmTypePackagingReprocessed.name);
      this.mainData.TipoEnvasado = newPackagingReprocessed;
    },
    ConfirmNewDataForNewPale(newDataForNewPale) {
      Log(this, this.ConfirmNewDataForNewPale.name);
      this.mainData.InfoNuevoPale = newDataForNewPale;
    },
    ConfirmScanData(value) {
      Log(this, this.ConfirmScanData.name);
      this.ProcessPaleRead(value);
    },
    GetContainerFromPale(objPale) {
      Log(this, this.GetContainerFromPale.name);
      const tempAcumuladosEnvase = objPale.Existencias.filter((e) => e.Articulo.TipoArticulo === 'Envase');
      if (tempAcumuladosEnvase.length > 1) {
        return `${tempAcumuladosEnvase[0].Articulo.Nombre} (+)`;
      }
      return tempAcumuladosEnvase[0].Articulo.Nombre;
    },
    DeletePaleSelection(val) {
      for (let i = 0; i < this.mainData.Mercancia.length; i += 1) {
        const element = this.mainData.Mercancia[i];
        if (val.NumeroSerie === element.NumeroSerie) {
          this.mainData.Mercancia.splice(i, 1);
        }
      }

      this.CalculateTotalBoxesTransfer();
    },

    async GETInfoPickingUL(idPale) {
      const result = await ConexionTA.callConsultarEstadoULParaUsoPicking(idPale);
      if (result.Valor) {
        const lstEstadoUnidadLogisticaPicking = JSON.parse(result.Mensaje);
        if (lstEstadoUnidadLogisticaPicking != null && lstEstadoUnidadLogisticaPicking.length > 0) {
          return lstEstadoUnidadLogisticaPicking[0];
        }
      }
      return false;
    },
    async SENDDeleteReservation(lstReservations, restoreMerchandiseToOrigin) {
      Log(this, this.SENDDeleteReservation.name);
      const result = await ConexionTA.callEliminarReservaDePaleLineaPedidoParaPicking(lstReservations, restoreMerchandiseToOrigin);
      return result.Valor;
    },
  },
};
</script>

<style lang="scss">
.content-gestion-traspasos {
  background-color: #fff;
  overflow-y: scroll;

  &__cabecera {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #ebecf0;

    >div {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      &:first-child {
        width: 265px;

        img {
          margin-right: 10px;
        }
      }

      &:not(:first-child) {
        span:first-child {
          margin-right: 5px;
        }
      }
    }

    &--buttons {
      img {
        cursor: pointer;
      }
    }
  }

  &__item {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    height: 80px;

    >div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-direction: column;

      &:first-child {
        align-items: flex-start;
        width: 265px;
      }

      &:nth-child(2) {
        span:first-child {
          margin-bottom: 8px;
        }
      }

      &:last-child {
        align-self: center;
        display: flex;
        flex-direction: row;
        align-items: center;

        :first-child,
        :nth-child(2) {
          margin-right: 10px;
        }
      }
    }

    &--counter {
      max-width: 150px;
    }
  }

  &__cabecera,
  &__item {
    &--strong {
      color: var(--his-steel-blue);
      font-size: 18px;
      font-weight: 700;
    }

    &--ligh {
      color: var(--his-oliva);
      font-size: 14px;
      font-weight: 400;
    }
  }

  &__list {
    height: calc(50vh - 200px);
    overflow-y: scroll;

    @media (max-height: 550px) {
      height: calc(100vh - 110px) !important;
      max-height: 180px;
    }
  }
}

.content-paletizado-buttons {
  background-color: #ebecf0;

  .color-letra {
    color: #fff;
  }

  .color-tipo-envasado {
    background: var(--his-dark-blue);
  }

  .button {
    width: 150px;
  }
}

.disabled {
  opacity: 0.6;
  pointer-events: none;
}
</style>
